import { invariant } from '@epic-web/invariant'
import { useRootLoaderData } from '#app/root.tsx'
import { type AppRequestInfo } from './get-request-info'

/**
 * @returns the request info from the root loader
 */
export function useRequestInfo(): AppRequestInfo {
	const { requestInfo } = useRootLoaderData()

	invariant(requestInfo, 'No requestInfo found in root loader')

	return requestInfo as AppRequestInfo
}

export function useOptionalRequestInfo(): AppRequestInfo | undefined {
	const { requestInfo } = useRootLoaderData()

	return requestInfo as AppRequestInfo | undefined
}
